import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        brand: 'Jobs',
        jobs: 'Jobs',
        applications: 'My Applications',
        myJobs: 'My Jobs',
        postulations: 'Postulations',
        stats: 'Stats',
        constanciaRequired: 'A constancia document is required for job seekers.',
        emailAlreadyRegistered: 'That email is already registered for this role.',
        postJob: 'Post a Job',
        approvals: 'Approvals',
        users: 'Users',
        profile: 'My Profile',
        login: 'Login',
        register: 'Register',
        logout: 'Logout'
      },
      common: {
        accessRestricted: 'Access restricted',
        accessDenied: 'Access denied. Only admins and moderators can view this page.',
        onlyPosters: 'Only job posters or admins can create job postings.',
        roles: {
          jobSeeker: 'Job Seeker',
          jobPoster: 'Job Poster',
          moderator: 'Moderator',
          admin: 'Admin'
        },
        remote: 'Remote',
        salaryTbd: 'Salary TBD',
        applyNow: 'Apply Now',
        editJob: 'Edit Job',
        cancel: 'Cancel',
        remove: 'Remove',
        cuitCuil: 'CUIT/CUIL',
        resume: 'Resume',
        phone: 'Phone',
        dni: 'DNI',
        bio: 'Bio',
        career: 'Career',
        skills: 'Skills',
        companyWebsite: 'Company website',
        profilePicture: 'Profile picture',
        viewDetails: 'View details',
        hideDetails: 'Hide details',
      },
      experienceRanges: {
        zeroToOne: '0-1 years',
        twoToThree: '2-3 years',
        fourToSix: '4-6 years',
        sevenPlus: '7+ years'
      },
      jobCategories: {
        therapeuticAssistant: 'Therapeutic assistant',
        schoolAssistant: 'School assistant',
        hr: 'HR',
        psychologyProfessional: 'Psychology professional',
        docenteTutor: 'Docente/tutor',
        musicoterapeuta: 'Musicoterapeuta',
        terapistaOcupacional: 'Terapista ocupacional',
        selectorPersonal: 'Selector/a de personal',
        personalAdministrativo: 'Personal administrativo',
        orientadorSala: 'Orientador/a de sala',
        acompananteGerontologico: 'Acompañante gerontológico',
        coordinadorIntegraciones: 'Coordinador/a de integraciones',
        supervisorAts: 'Supervisor/a de ATs',
        other: 'Other'
      },
      careers: {
        musicotherapy: 'Music therapy',
        psychology: 'Psychology',
        psychologyTeaching: 'Psychology teaching',
        occupationalTherapy: 'Occupational therapy'
      },
      login: {
        title: 'Portal Login',
        subtitle: 'All users must sign in to continue.',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        role: 'Role',
        submit: 'Sign In',
        invalidCredentials: 'Invalid credentials. Please try again.',
        pendingApproval: 'Your account is pending approval.',
        needAccount: 'Need an account?',
        register: 'Register'
      },
      register: {
        title: 'Create Account',
        subtitle: 'Admins and moderators approve new users after registration.',
        username: 'Username',
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneLabel: 'Phone number',
        phonePlaceholder: 'Enter your phone number',
        dniLabel: 'DNI',
        careerLabel: 'Career',
        careerPlaceholder: 'Select your career',
        companyName: 'Company name',
        cuitCuilNumberLabel: 'CUIT/CUIL number',
        cuitCuilNumberPlaceholder: 'Enter your CUIT/CUIL',
        cuitCuilLabel: 'CUIT/CUIL document',
        cuitCuilPlaceholder: 'Upload PDF or image',
        password: 'Password',
        passwordHint: 'Use 8+ chars with upper, lower, number, and symbol.',
        confirm: 'Confirm Password',
        role: 'Role',
        roles: {
          jobSeeker: 'Job Seeker',
          jobPoster: 'Job Poster'
        },
        submit: 'Register',
        passwordTooShort: 'Password must be at least 8 characters long.',
        passwordMismatch: 'Passwords must match.',
        passwordComplexity: 'Password must include uppercase, number, and symbol.',
        constanciaRequired: 'A constancia document is required for job seekers.',
        constanciaInvalidType: 'The constancia document must be PDF, JPG, PNG, DOC, or DOCX.',
        constanciaMaxSize: 'The constancia document must be 10MB or less.',
        adminNotAllowed: 'Admin or moderator accounts cannot be created from registration.',
        firstNameRequired: 'First name is required.',
        lastNameRequired: 'Last name is required.',
        careerRequired: 'Career is required for job seekers.',
        cuitCuilRequired: 'CUIT/CUIL document is required for job posters.',
        cuitCuilNumberRequired: 'CUIT/CUIL number is required for job posters.',
        cuitCuilNumberInvalid: 'CUIT/CUIL number must be 11 digits.',
        emailRequired: 'Email is required.',
        emailInvalid: 'Enter a valid email address.',
        phoneRequired: 'Phone number is required.',
        phoneInvalid: 'Phone number must be at least 10 digits.',
        dniRequired: 'DNI is required for job seekers.',
        dniInvalid: 'DNI must be 6 to 8 digits.',
        privacyAcceptLabel: 'I accept the processing of my personal data to manage my profile in the job board, receive relevant offers, and allow contact from institutions and the Subsecretariat.',
        privacyOpen: 'Read policy',
        privacyTitle: 'Privacy Policy',
        privacyBody: 'Privacy policy text will be provided.',
        privacyClose: 'Close',
        termsRequired: 'You must accept the Privacy Policy.',
        success: 'Registration successful! Your account is pending approval.',
        error: 'Registration failed. Please try again.',
        pendingApproval: 'Your account is pending approval.',
        haveAccount: 'Already have an account?',
        login: 'Login'
      },
      applications: {
        title: 'Mis postulaciones',
        subtitle: 'Sigue los empleos a los que aplicaste.',
        statusPending: 'Pendiente',
        statusReviewed: 'Revisada',
        statusShortlisted: 'Preseleccionada',
        statusRejected: 'Rechazada',
        statusAccepted: 'Aceptada',
        forPosters: 'Para empresas',
        manageHint: 'Usa la sección Mis avisos para revisar postulantes.',
        withdraw: 'Dar de baja postulacion',
        withdrawnByApplicant: 'El postulante ha retirado su postulacion.',
        withdrawnShort: 'Baja',
        modifiedShort: 'Modificada',
        reapplyBlocked: 'Ya no puedes reaplicar a este empleo.',
        withdrawError: 'No se pudo dar de baja la postulacion',
        loadError: 'No se pudieron cargar las postulaciones',
        reapply: 'Reaplicar',
        withdrawFinalTitle: 'Última baja',
        withdrawFinalMessage: 'Si das de baja tu postulación otra vez, no podrás reaplicar a este empleo. ¿Confirmás la baja?',
        withdrawFinalConfirm: 'Dar de baja definitivamente',
        applySuccessTitle: 'Postulacion enviada',
        applySuccess: 'Tu postulacion se envio correctamente.',
        careerLabel: 'Carrera',
        careerPlaceholder: 'Selecciona o escribe tu carrera',
        careerHelp: 'Si estas cursando mas de una carrera, selecciona aquella en la que tenes mayor grado de avance o consideras mas relevante para esta postulacion. Podes sumar las aclaraciones que consideres en la carta de presentacion.',
        careerTitle: 'Datos de carrera',
        progressLabel: 'Nivel de avance',
        progressPlaceholder: 'Selecciona nivel',
        progress: {
          initial: 'Inicial (menos de 10 materias)',
          intermediate: 'Intermedio (10 a 22 materias)',
          advanced: 'Avanzado (23+ materias)'
        },
        filters: {
          status: 'Filtrar por estado',
          all: 'Todas'
        },
        markReview: 'Marcar revision',
        statusTitle: 'Estado de la postulacion',
        statusLabel: 'Estado',
        statusSave: 'Guardar estado',
        selectedSkills: 'Habilidades seleccionadas',
        viewFull: 'Ver aplicacion completa',
        minimize: 'Minimizar',
        privateNoteLabel: 'Nota privada',
        privateNotePlaceholder: 'Agregar una nota privada sobre este postulante',
        privateNoteSave: 'Guardar nota'
      },
      postulations: {
        title: 'Postulantes a tus ofertas de empleo',
        subtitle: 'Revisá las postulaciones a tus ofertas',
        empty: 'Aun no hay postulaciones',
        emptyForJob: 'Aun no se registraron postulaciones.',
        filterJobLabel: 'Filtrar por oferta',
        filterJobPlaceholder: 'Selecciona una oferta',
        filterAllJobs: 'Todas las ofertas',
        applied: 'Postulo',
        atTag: 'AT',
        onlyPosters: 'Solo empresas pueden ver postulaciones.',
        downloadZip: 'Descargar CVs',
        noCvsAvailable: 'No hay aun CVs disponibles para esa oferta',
        lastBulkDownload: 'Última descarga masiva: {{date}}',
        noBulkDownload: 'Sin descargas masivas'
      },
      posterBody: 'Receive applications with CVs and cover letters. Organize and manage your selection process from a single dashboard.',
      showDetails: 'Show details',
      hideDetails: 'Hide details',
      footerText: 'Bolsa de Empleo - Bienestar Estudiantil',
      footerEmailLabel: 'Contact:',
      footerEmail: 'bienestarestudiantil@psi.uba.ar',
      logoAlt: 'Portal logo'
    },
    jobDetail: {
      notFound: 'Job not found',
      goBack: 'Go Back',
      experienceLevel: '{{level}} level',
      category: 'Category',
      requiresAtCourse: 'Requires AT course',
      requiresAtDiplomaUba: 'Requires AT Diploma UBA',
      requiresDegreeTitle: 'Requires degree title',
      requiresSchoolInclusionCourse: 'Requires school inclusion course',
      requiresHrCourses: 'Requires HR courses',
      otherSkills: 'Other skills:',
      applicantsTitle: 'Applicants ({{count}})',
      noApplicants: 'No applicants yet',
      applied: 'Applied',
      view: 'View',
      review: 'View full application',
      applyToJob: 'Apply to Job',
      resumeLabel: 'Resume (PDF)',
      resumePlaceholder: 'Upload your resume',
      coverLetterLabel: 'Cover Letter (Optional)',
      coverLetterPlaceholder: "Tell the employer why you're a great fit...",
      cancel: 'Cancel',
      submitApplication: 'Submit Application',
      applicationFrom: 'Application from {{name}}',
      coverLetter: 'Cover Letter',
      resume: 'Resume',
      download: 'Download',
      applicationStatus: 'Application Status',
      hideApplicants: 'Hide applicants'
    },
    createJob: {
      title: 'Create Job Posting',
      careersRequired: 'Select at least one career.',
      requirementsTitle: 'Requirements',
      fields: {
        title: 'Position',
        company: 'Company',
        location: 'Location',
        remote: 'Remote friendly',
        jobType: 'Job type',
        experience: 'Experience (years)',
        category: 'Category',
        categoryOther: 'Other: specify position',
        salary: 'Salary range',
        shortDescription: 'Short description (max 120)',
        description: 'Description',
        requiresAtCourse: 'Requires AT course',
        requiresAtDiplomaUba: 'Requires AT Diploma UBA',
        requiresDegreeTitle: 'Requires degree title',
        requiresSchoolInclusionCourse: 'Requires school inclusion course',
        requiresHrCourses: 'Requires HR courses',
        otherSkills: 'Other skills',
        careers: 'Careers',
        careersPlaceholder: 'Select careers'
      },
      submit: 'Publish Job'
    },
    editJob: {
      title: 'Edit Job Posting',
      save: 'Save Changes'
    },
    applications: {
      title: 'My Applications',
      subtitle: 'Track jobs you have applied to.',
      statusPending: 'Pending',
      statusReviewed: 'Reviewed',
      statusShortlisted: 'Shortlisted',
      statusRejected: 'Rejected',
      statusAccepted: 'Accepted',
      forPosters: 'For job posters',
      manageHint: 'Use the My Posted Jobs page to review applicants.',
      withdraw: 'Withdraw application',
      withdrawnByApplicant: 'Applicant withdrew their application.',
      withdrawnShort: 'Withdrawn',
      modifiedShort: 'Modified',
      reapplyBlocked: 'You cannot reapply to this job after withdrawing again.',
      withdrawError: 'Failed to withdraw application',
      loadError: 'Failed to load applications',
      reapply: 'Reapply to job',
      withdrawFinalTitle: 'Final withdrawal',
      withdrawFinalMessage: 'If you withdraw again, you will not be able to reapply to this job. Do you want to continue?',
      withdrawFinalConfirm: 'Withdraw permanently',
      applySuccessTitle: 'Application sent',
      applySuccess: 'Your application was submitted successfully.',
      careerLabel: 'Career',
      careerPlaceholder: 'Select or type your career',
      careerHelp: 'If you are enrolled in more than one career, choose the one with the highest progress or the most relevant for this application. You can add clarifications in the cover letter.',
      careerTitle: 'Career details',
      progressLabel: 'Progress level',
      progressPlaceholder: 'Select progress',
      progress: {
        initial: 'Initial (under 10 subjects)',
        intermediate: 'Intermediate (10 to 22 subjects)',
        advanced: 'Advanced (23+ subjects)'
      },
      filters: {
        status: 'Filter by status',
        all: 'All'
      },
      markReview: 'Mark review',
      statusTitle: 'Application status',
      statusLabel: 'Status',
      statusSave: 'Save status',
      selectedSkills: 'Selected skills',
      viewFull: 'View full application',
      minimize: 'Minimize',
      privateNoteLabel: 'Private note',
      privateNotePlaceholder: 'Add a private note for this applicant',
      privateNoteSave: 'Save note'
    },
    postulations: {
      title: 'Postulations',
      subtitle: 'Review applications sent to your job postings',
      empty: 'No applications yet',
      emptyForJob: 'No applications have been registered yet.',
      filterJobLabel: 'Filter by job',
      filterJobPlaceholder: 'Select a job',
      filterAllJobs: 'All jobs',
      applied: 'Applied',
      atTag: 'AT',
      onlyPosters: 'Only job posters can view postulations.',
      downloadZip: 'Download CVs',
      noCvsAvailable: 'No CVs available yet',
      lastBulkDownload: 'Last bulk download: {{date}}',
      noBulkDownload: 'No bulk downloads yet'
    },
    stats: {
      title: 'Stats',
      jobsTotal: 'Total jobs',
      jobsActive: 'Active jobs',
      jobsInactive: 'Inactive jobs',
      applicationsTotal: 'Total applications',
      usersTotal: 'Job seekers total',
      filterYear: 'Year',
      allYears: 'All years',
      jobsTableTitle: 'Jobs by year',
      applicationsTableTitle: 'Applications by year',
      applicationsByCareerTitle: 'Applications by career',
      usersByCareerTitle: 'Job seekers by career',
      tableCareer: 'Career',
      tableYear: 'Year',
      tableTotal: 'Total',
      tableActive: 'Active',
      tableInactive: 'Inactive',
      careerUnspecified: 'Unspecified',
      onlyModerators: 'Only moderators can view this page.',
      loadError: 'Failed to load stats',
      errorTitle: 'Error'
    },
    approvals: {
      title: 'Approvals Dashboard',
      pendingUsers: 'Pending Users',
      pendingJobs: 'Pending Jobs',
      phoneDuplicates: 'Phone Duplicates',
      dniDuplicates: 'DNI Duplicates',
      noPendingUsers: 'No pending user approvals',
      noPendingJobs: 'No pending job approvals',
      noPhoneDuplicates: 'No duplicate phone numbers found',
      noDniDuplicates: 'No duplicate DNI found',
      phoneDuplicatesTitle: 'Duplicate phone numbers',
      dniDuplicatesTitle: 'Duplicate DNI',
      exportCsv: 'Export CSV',
      onlyPending: 'Pending only',
      onlyJobSeekers: 'Job seekers only',
      onlyResolved: 'Resolved only',
      startDate: 'Start date',
      endDate: 'End date',
      rolesInvolved: 'Roles involved',
      totalAccounts: '{{count}} accounts',
      pendingAccounts: '{{count}} pending',
      approvedAccounts: '{{count}} approved',
      validated: 'Resolved',
      validatedAt: 'Resolved at {{date}}',
      notValidated: 'Unresolved',
      markValidated: 'Mark resolved',
      userName: 'Name',
      userEmail: 'Email',
      userRole: 'Role',
      userStatus: 'Status',
      userCreated: 'Created',
      userLastLogin: 'Last login',
      statusApproved: 'Approved',
      statusPending: 'Pending',
      statusRejected: 'Rejected',
      requested: 'Requested',
      posted: 'Posted',
      editJob: 'Edit job',
      approve: 'Approve',
      reject: 'Reject',
      constancia: 'Constancia',
      cuitCuil: 'CUIT/CUIL',
      cuitCuilNumber: 'CUIT/CUIL number',
      resume: 'Resume',
      phone: 'Phone',
      dni: 'DNI',
      bio: 'Bio',
      career: 'Career',
      skills: 'Skills',
      companyWebsite: 'Company website',
      profilePicture: 'Profile picture',
      viewDocument: 'View document',
      pendingApproval: 'Pending Approval',
      loadError: 'Failed to load pending items',
      phonesLoadError: 'Failed to load phone duplicates',
      phoneValidateError: 'Failed to mark phone as validated',
      dnisLoadError: 'Failed to load DNI duplicates',
      dniValidateError: 'Failed to mark DNI as resolved',
      approveUserError: 'Failed to approve user',
      rejectUserError: 'Failed to reject user',
      approveJobError: 'Failed to approve job',
      rejectJobError: 'Failed to reject job'
    },
    postedJobs: {
      title: 'My Posted Jobs',
      subtitle: 'Manage the jobs you have published.',
      empty: 'No jobs yet. Post one to get started.',
      onlyPosters: 'Only job posters, moderators, or admins can view posted jobs.',
      forPosters: 'For job posters',
      viewPostulations: 'View postulations',
      applicants: 'applicants',
      active: 'Active',
      inactive: 'Inactive',
      reactivate: 'Reactivate',
      deactivate: 'Deactivate',
      filterActive: 'Active only',
      filterInactive: 'Inactive only',
      filterAll: 'All'
    },
    users: {
      title: 'Users',
      subtitle: 'View and edit user accounts.',
      export: {
        csv: 'Export CSV',
        xlsx: 'Export XLSX',
        email: 'Email',
        phone: 'Phone',
        firstName: 'First name',
        lastName: 'Last name',
        activityTotal: 'Activity (total)',
        activity6m: 'Activity (6m)',
        name: 'Name',
        role: 'Role',
        status: 'Status'
      },
      noUsers: 'No users found.',
      loadError: 'Failed to load users',
      updateError: 'Failed to update user',
      updated: 'User updated successfully',
      editTitle: 'Edit user',
      save: 'Save',
      cancel: 'Cancel',
      password: {
        new: 'New password',
        confirm: 'Confirm password',
        mismatch: 'Passwords do not match.',
        tooShort: 'Password must be at least 8 characters long.'
      },
      filters: {
        role: 'Role',
        approval: 'Approval',
        allRoles: 'All roles',
        allApprovals: 'All',
        approved: 'Approved',
        pending: 'Pending',
        rejected: 'Rejected'
      },
      search: {
        label: 'Search',
        placeholder: 'Name, email, or DNI',
        requiresAtCourse: 'Requiere curso de AT',
        requiresAtDiplomaUba: 'Requiere Diplomatura de AT UBA',
        requiresDegreeTitle: 'Requiere titulo de grado',
        requiresSchoolInclusionCourse: 'Requiere curso de inclusion escolar',
        requiresHrCourses: 'Requiere cursos en Recursos Humanos'
      },
      table: {
        email: 'Email',
        phone: 'Phone',
        activity: 'Activity',
        name: 'Name',
        role: 'Role',
        approved: 'Approved',
        actions: 'Actions',
        edit: 'Edit'
      },
      activity: {
        applicationsTotal: 'Applications (total): {{count}}',
        applications6m: 'Applications (6m): {{count}}',
        jobsTotal: 'Job posts (total): {{count}}',
        jobs6m: 'Job posts (6m): {{count}}'
      },
      fields: {
        email: 'Email',
        firstName: 'First name',
        lastName: 'Last name',
        dni: 'DNI',
        userType: 'User type',
        approved: 'Approved',
        phone: 'Phone',
        companyName: 'Company name',
        companyWebsite: 'Company website',
        bio: 'Bio',
        skills: 'Skills',
        skillsHint: 'Comma-separated list',
        profilePicture: 'Profile picture',
        resume: 'Resume',
        constancia: 'Constancia',
        viewFile: 'View file'
      }
    },
    profile: {
      title: 'User Profile',
      subtitle: 'Basic account details.',
      username: 'Username',
      email: 'Email',
      role: 'Role',
      approved: 'Approved',
      approvedYes: 'Yes',
      approvedPending: 'Pending',
      editTitle: 'Edit profile',
      save: 'Save changes',
      updated: 'Profile updated successfully',
      fields: {
        firstName: 'First name',
        lastName: 'Last name',
        career: 'Career',
        dni: 'DNI',
        phone: 'Phone',
        cuitCuil: 'CUIT/CUIL number',
        companyName: 'Company name',
        companyWebsite: 'Company website',
        bio: 'Bio',
        skills: 'Skills',
        skillsHint: 'Comma-separated list'
      },
      password: {
        title: 'Change password',
        current: 'Current password',
        new: 'New password',
        confirm: 'Confirm password',
        save: 'Update password',
        updated: 'Password updated successfully',
        mismatch: 'Passwords do not match.',
        tooShort: 'Password must be at least 8 characters long.'
      }
    }
  },
  es: {
    translation: {
      nav: {
        brand: 'Empleos',
        jobs: 'Empleos',
        applications: 'Mis postulaciones',
        myJobs: 'Mis avisos',
        postulations: 'Postulaciones',
        stats: 'Estadisticas',
        postJob: 'Publicar empleo',
        approvals: 'Aprobaciones',
        users: 'Usuarios',
        profile: 'Mi perfil',
        login: 'Ingresar',
        register: 'Registrarse',
        logout: 'Salir'
      },
      common: {
        accessRestricted: 'Acceso restringido',
        accessDenied: 'Acceso denegado. Solo administradores y moderadores pueden ver esta página.',
        onlyPosters: 'Solo empresas o administradores pueden crear avisos.',
        roles: {
          jobSeeker: 'Postulante',
          jobPoster: 'Oferente',
          moderator: 'Moderador',
          admin: 'Administrador'
        },
        remote: 'Remoto',
        salaryTbd: 'Salario a definir',
        applyNow: 'Postular ahora',
        editJob: 'Editar aviso',
        cancel: 'Cancelar',
        remove: 'Quitar'
      },
      experienceRanges: {
        zeroToOne: '0-1 años',
        twoToThree: '2-3 años',
        fourToSix: '4-6 años',
        sevenPlus: '7+ años'
      },
      jobCategories: {
        therapeuticAssistant: 'Acompañante terapéutico',
        schoolAssistant: 'Acompañante escolar',
        hr: 'Recursos Humanos',
        psychologyProfessional: 'Psicólogo/a',
        docenteTutor: 'Docente/tutor',
        musicoterapeuta: 'Musicoterapeuta',
        terapistaOcupacional: 'Terapista ocupacional',
        selectorPersonal: 'Selector/a de personal',
        personalAdministrativo: 'Personal administrativo',
        orientadorSala: 'Orientador/a de sala',
        acompananteGerontologico: 'Acompañante gerontológico',
        coordinadorIntegraciones: 'Coordinador/a de integraciones',
        supervisorAts: 'Supervisor/a de ATs',
        other: 'Otro'
      },
      careers: {
        musicotherapy: 'Musicoterapia',
        psychology: 'Psicologia',
        psychologyTeaching: 'Profesorado en Psicologia',
        occupationalTherapy: 'Terapia Ocupacional'
      },
      login: {
        title: 'Ingreso a la bolsa de empleo | bienestar estudiantil',
        subtitle: 'Todos los usuarios deben autenticarse para continuar.',
        username: 'Usuario',
        email: 'Correo',
        password: 'Contraseña',
        role: 'Rol',
        submit: 'Ingresar',
        invalidCredentials: 'Credenciales inválidas. Inténtalo de nuevo.',
        pendingApproval: 'Tu cuenta está pendiente de aprobación.',
        needAccount: '¿No tenés cuenta?',
        register: 'Registrate'
      },
      register: {
        title: 'Crear cuenta',
        subtitle: 'La cuenta debe ser aprobada por un/a admin.',
        username: 'Usuario',
        email: 'Correo',
        firstName: 'Nombre',
        lastName: 'Apellido',
        phoneLabel: 'Teléfono',
        phonePlaceholder: 'Ingresá tu teléfono',
        dniLabel: 'DNI',
        careerLabel: 'Carrera',
        careerPlaceholder: 'Selecciona tu carrera',
        companyName: 'Nombre de la empresa',
        cuitCuilNumberLabel: 'CUIT/CUIL (número)',
        cuitCuilNumberPlaceholder: 'Ingresá tu CUIT/CUIL',
        cuitCuilLabel: 'CUIT/CUIL (PDF o imagen)',
        cuitCuilPlaceholder: 'Subí una constancia de CUIT/CUIL',
        password: 'Contraseña',
        passwordHint: 'Usa 8+ caracteres con mayúscula, minúscula, número y símbolo.',
        confirm: 'Confirmar contraseña',
        role: 'Rol',
        roles: {
          jobSeeker: 'Busco empleo',
          jobPoster: 'Ofrezco empleo'
        },
        submit: 'Registrarse',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
        passwordMismatch: 'Las contraseñas deben coincidir.',
        passwordComplexity: 'La contraseña debe incluir mayúscula, número y símbolo.',
        constanciaRequired: 'La constancia es obligatoria para postulantes.',
        constanciaInvalidType: 'La constancia debe ser PDF, JPG, PNG, DOC o DOCX.',
        constanciaMaxSize: 'La constancia debe pesar 10MB o menos.',
        emailAlreadyRegistered: 'Ese correo ya está registrado para ese rol.',
        adminNotAllowed: 'No se pueden crear cuentas admin o moderador desde el registro.',
        firstNameRequired: 'El nombre es obligatorio.',
        lastNameRequired: 'El apellido es obligatorio.',
        careerRequired: 'La carrera es obligatoria para postulantes.',
        cuitCuilRequired: 'Subir el CUIT/CUIL es obligatorio para oferentes.',
        cuitCuilNumberRequired: 'El número de CUIT/CUIL es obligatorio para oferentes.',
        cuitCuilNumberInvalid: 'El número de CUIT/CUIL debe tener 11 dígitos.',
        emailRequired: 'El correo es obligatorio.',
        emailInvalid: 'Ingresá un correo válido.',
        phoneRequired: 'El teléfono es obligatorio.',
        phoneInvalid: 'El teléfono debe tener al menos 10 dígitos.',
        dniRequired: 'El DNI es obligatorio para postulantes.',
        dniInvalid: 'El DNI debe tener entre 6 y 8 dígitos.',
        privacyAcceptLabel: 'Acepto el tratamiento de mis datos personales con el fin de gestionar mi perfil en la bolsa de empleo, recibir ofertas de interés y el contacto por parte de las instituciones y de la Subsecretaría',
        privacyOpen: 'Leer política',
        privacyTitle: 'Política de Privacidad',
        privacyBody: 'POLÍTICA DE PRIVACIDAD\n\nPortal de Empleo [Nombre del Portal]\n\nÚltima actualización: [completar fecha]\n\n1. Responsable del tratamiento de datos\n\nEl responsable del tratamiento de los datos personales recolectados a través del presente Portal es [Nombre de la institución / Facultad / Universidad / Responsable legal], con domicilio en [domicilio legal], correo electrónico de contacto: [email institucional].\n\n2. Datos personales que se recolectan\n\nEl Portal podrá recolectar los siguientes datos personales:\n\nNombre y apellido\n\nDocumento de identidad (DNI o equivalente)\n\nDirección de correo electrónico\n\nDatos académicos y laborales\n\nInformación contenida en el currículum vitae (CV)\n\nDatos de contacto\n\nHistorial de postulaciones\n\nCualquier otro dato que el usuario proporcione voluntariamente\n\nEn el caso de empleadores, podrán recolectarse datos institucionales, de contacto y de identificación del responsable de la oferta laboral.\n\n3. Finalidad del tratamiento\n\nLos datos personales serán tratados con las siguientes finalidades:\n\nGestionar el registro y autenticación de usuarios\n\nPermitir la postulación a ofertas laborales\n\nFacilitar el contacto entre postulantes y empleadores\n\nAdministrar procesos de validación o aprobación de cuentas\n\nEnviar comunicaciones relacionadas con el funcionamiento del Portal\n\nGenerar estadísticas internas de uso, de manera anonimizada\n\nLos datos no serán utilizados para finalidades distintas a las aquí indicadas sin consentimiento previo.\n\n4. Base legal\n\nEl tratamiento de los datos se realiza conforme al consentimiento libre, expreso e informado del titular, en cumplimiento de la Ley 25.326 de Protección de los Datos Personales de la República Argentina.\n\n5. Cesión o comunicación de datos\n\nLos datos personales de los postulantes podrán ser comunicados exclusivamente a los empleadores que publiquen ofertas laborales en el Portal y únicamente en el marco de una postulación voluntaria realizada por el propio usuario.\n\nNo se comercializan ni transfieren datos personales a terceros ajenos al funcionamiento del Portal.\n\n6. Almacenamiento y seguridad\n\nEl Portal adopta medidas técnicas y organizativas razonables para proteger los datos personales contra acceso no autorizado, pérdida, alteración o divulgación indebida.\n\nLos datos podrán almacenarse en servidores propios o en servicios de infraestructura tecnológica contratados a terceros que cumplan estándares adecuados de seguridad.\n\n7. Conservación de los datos\n\nLos datos personales serán conservados mientras el usuario mantenga su cuenta activa o durante el tiempo necesario para cumplir con las finalidades descriptas, salvo que el titular solicite su eliminación.\n\n8. Derechos del titular de los datos\n\nEl titular de los datos podrá ejercer en cualquier momento los derechos de:\n\nAcceso\n\nRectificación\n\nActualización\n\nSupresión\n\nmediante solicitud enviada a: [correo de contacto].\n\nDe conformidad con el artículo 14, inciso 3 de la Ley 25.326, el titular tiene derecho a ejercer el derecho de acceso a sus datos en forma gratuita a intervalos no inferiores a seis meses, salvo que acredite un interés legítimo al efecto.\n\nLa Agencia de Acceso a la Información Pública, en su carácter de órgano de control de la Ley 25.326, tiene la atribución de atender denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales.\n\n9. Consentimiento\n\nAl registrarse en el Portal y aceptar la presente Política de Privacidad, el usuario presta su consentimiento libre, expreso e informado para el tratamiento de sus datos personales conforme a los términos aquí establecidos.\n\n10. Modificaciones\n\nEl responsable se reserva el derecho de modificar la presente Política de Privacidad en cualquier momento. Las modificaciones serán publicadas en el Portal con indicación de la fecha de actualización.',
        privacyClose: 'Cerrar',
        termsRequired: 'Se requiere aceptar la Política de Privacidad.',
        success: '¡Registro exitoso! Tu cuenta está pendiente de aprobación.',
        error: 'Error al registrarse. Por favor intentá nuevamente.',
        pendingApproval: 'Tu cuenta está pendiente de aprobación.',
        haveAccount: '¿Ya tenés cuenta?',
        login: 'Ingresar'
      },
      dashboard: {
        title: 'Panel de empleos',
        subtitle: 'Revisá los empleos aprobados disponibles para todos.',
        noJobs: 'No hay empleos disponibles',
        filters: 'Filtros',
        category: 'Categoria',
        allCategories: 'Todas las categorias',
        positions: 'Tipo de puesto',
        allPositions: 'Todos los puestos',
        positionOtherLabel: 'Especificar el puesto',
        positionOtherPlaceholder: 'Escribí el nombre del puesto',
        careers: 'Carreras afines',
        allCareers: 'Todas las carreras',
        requiresAtCourse: 'Requiere curso de AT',
        requiresAtDiplomaUba: 'Requiere Diplomatura de AT UBA',
        requiresDegreeTitle: 'Requiere titulo de grado',
        requiresSchoolInclusionCourse: 'Requiere trayectoria IE',
        requiresHrCourses: 'Requiere cursos en Recursos Humanos',
        activeOnly: 'Solo activas'
      },
      publicHome: {
        title: 'Bolsa de empleo | Bienestar Estudiantil',
        subtitle: 'Encontrá oportunidades o publicá nuevas ofertas en un solo lugar.',
        body: 'La Bolsa de Empleo funciona como nexo entre las instituciones y empleadores que tienen busquedas laborales y los estudiantes de las carreras de Psicologia, Musicoterapia y Terapia Ocupacional que conforman la poblacion de nuestra Facultad. Cuenta con diversas ofertas laborales actualizadas y subidas en la seccion de Empleos. Desde 2018 publicamos mas de 1500 ofertas laborales dirigidas a estudiantes de la Facultad.',
        registrationNote: 'Al registrarte deberás indicar si buscas empleo o querés publicar búsquedas laborales. La cuenta debe ser aprobada por un moderador antes de que puedas acceder.',
        seekerTitle: 'Busco empleo',
        seekerLead: 'Accedé a oportunidades laborales orientadas a estudiantes de la Facultad de Psicología (UBA).',
        seekerBody: 'Postulate cargando tu CV y, opcionalmente, una breve presentación personal. Visualizá y gestioná todas tus postulaciones en un solo espacio.',
        posterTitle: 'Quiero publicar una búsqueda',
        posterLead: 'Publicá búsquedas laborales dirigidas a perfiles de la Facultad de Psicología (UBA).',
        posterBody: 'Recibí postulaciones con CV y notas de presentación. Organizá y gestioná tus procesos de selección desde un mismo lugar.',
        showDetails: 'Ver más',
        hideDetails: 'Ocultar',
        footerText: 'Bolsa de Empleo - Bienestar Estudiantil',
        footerEmailLabel: 'Consultas:',
        footerEmail: 'bienestarestudiantil@psi.uba.ar',
        logoAlt: 'Logo del portal'
      },
      jobDetail: {
        notFound: 'Empleo no encontrado',
        goBack: 'Volver',
        experienceLevel: 'Nivel {{level}}',
        category: 'Categoria',
        requiresAtCourse: 'Requiere curso de AT',
        requiresAtDiplomaUba: 'Requiere Diplomatura de AT UBA',
        requiresDegreeTitle: 'Requiere titulo de grado',
        requiresSchoolInclusionCourse: 'Requiere curso de inclusion escolar',
        requiresHrCourses: 'Requiere cursos en Recursos Humanos',
        otherSkills: 'Otras habilidades:',
        applicantsTitle: 'Postulantes ({{count}})',
        noApplicants: 'Aun no hay postulantes',
        applied: 'Postulo',
        view: 'Ver',
        review: 'Ver aplicacion completa',
        applyToJob: 'Postular al empleo',
        resumeLabel: 'Curriculum (PDF)',
        resumePlaceholder: 'Subi tu curriculum',
        coverLetterLabel: 'Carta de presentacion (Opcional)',
        coverLetterPlaceholder: 'Conta por que sos un buen candidato...',
        cancel: 'Cancelar',
        submitApplication: 'Enviar postulacion',
        applicationFrom: 'Postulacion de {{name}}',
        coverLetter: 'Carta de presentacion',
        resume: 'Curriculum',
        download: 'Descargar CV',
        applicationStatus: 'Estado de la postulacion',
        hideApplicants: 'Ocultar postulantes'
      },
      createJob: {
        title: 'Crear aviso de empleo',
        careersRequired: 'Seleccioná al menos una carrera.',
        requirementsTitle: 'Requisitos',
        fields: {
          title: 'Puesto',
          company: 'Oferente',
          location: 'Ubicación',
          remote: 'Trabajo remoto',
          jobType: 'Tipo de empleo',
          experience: 'Experiencia (años)',
          category: 'Categoria',
          categoryOther: 'Otro: especifique el puesto',
          salary: 'Rango salarial',
          shortDescription: 'Descripcion breve (max 120)',
          description: 'Descripción completa',
          requiresAtCourse: 'Requiere curso de AT',
          requiresAtDiplomaUba: 'Requiere Diplomatura de AT UBA',
          requiresDegreeTitle: 'Requiere titulo de grado',
          requiresSchoolInclusionCourse: 'Requiere curso de inclusion escolar',
          requiresHrCourses: 'Requiere cursos en Recursos Humanos',
          otherSkills: 'Otras habilidades',
          careers: 'Carreras',
          careersPlaceholder: 'Selecciona carreras'
        },
        submit: 'Publicar empleo'
      },
      editJob: {
        title: 'Editar aviso',
        save: 'Guardar cambios'
      },
      applications: {
        title: 'Mis postulaciones',
        subtitle: 'Sigue los empleos a los que aplicaste.',
        statusPending: 'Pendiente',
        statusReviewed: 'Revisada',
        statusShortlisted: 'Preseleccionada',
        statusRejected: 'Rechazada',
        statusAccepted: 'Aceptada',
        forPosters: 'Para empresas',
        manageHint: 'Usa la sección Mis avisos para revisar postulantes.',
        withdraw: 'Dar de baja postulacion',
        withdrawnByApplicant: 'El postulante ha retirado su postulacion.',
        withdrawnShort: 'Baja',
        modifiedShort: 'Modificada',
        reapplyBlocked: 'Ya no puedes reaplicar a este empleo.',
        withdrawError: 'No se pudo dar de baja la postulacion',
        loadError: 'No se pudieron cargar las postulaciones',
        reapply: 'Reaplicar',
        withdrawFinalTitle: 'Última baja',
        withdrawFinalMessage: 'Si das de baja tu postulación otra vez, no podrás reaplicar a este empleo. ¿Confirmás la baja?',
        withdrawFinalConfirm: 'Dar de baja definitivamente',
        applySuccessTitle: 'Postulacion enviada',
        applySuccess: 'Tu postulacion se envio correctamente.',
        careerLabel: 'Carrera',
        careerPlaceholder: 'Selecciona o escribe tu carrera',
        careerHelp: 'Si estas cursando mas de una carrera, selecciona aquella en la que tenes mayor grado de avance o consideras mas relevante para esta postulacion. Podes sumar las aclaraciones que consideres en la carta de presentacion.',
        careerTitle: 'Datos de carrera',
        progressLabel: 'Nivel de avance',
        progressPlaceholder: 'Selecciona nivel',
        progress: {
          initial: 'Inicial (menos de 10 materias)',
          intermediate: 'Intermedio (10 a 22 materias)',
          advanced: 'Avanzado (23+ materias)'
        },
        filters: {
          status: 'Filtrar por estado',
          all: 'Todas'
        },
        markReview: 'Marcar revision',
        statusTitle: 'Estado de la postulacion',
        statusLabel: 'Estado',
        statusSave: 'Guardar estado',
        selectedSkills: 'Habilidades seleccionadas',
        viewFull: 'Ver aplicacion completa',
        minimize: 'Minimizar',
        privateNoteLabel: 'Nota privada',
        privateNotePlaceholder: 'Agregar una nota privada sobre este postulante',
        privateNoteSave: 'Guardar nota'
      },
      postulations: {
        title: 'Postulantes a tus ofertas de empleo',
        subtitle: 'Revisá las postulaciones a tus ofertas',
        empty: 'Aun no hay postulaciones',
        emptyForJob: 'Aun no se registraron postulaciones.',
        filterJobLabel: 'Filtrar por oferta',
        filterJobPlaceholder: 'Selecciona una oferta',
        filterAllJobs: 'Todas las ofertas',
        applied: 'Postulo',
        atTag: 'AT',
        onlyPosters: 'Solo empresas pueden ver postulaciones.',
        downloadZip: 'Descargar CVs',
        noCvsAvailable: 'No hay aun CVs disponibles para esa oferta',
        lastBulkDownload: 'Última descarga masiva: {{date}}',
        noBulkDownload: 'Sin descargas masivas'
      },
      stats: {
        title: 'Estadísticas',
        jobsTotal: 'Ofertas totales',
        jobsActive: 'Ofertas activas',
        jobsInactive: 'Ofertas inactivas',
        applicationsTotal: 'Postulaciones totales',
        usersTotal: 'Postulantes totales',
        filterYear: 'Año',
        allYears: 'Todos los años',
        jobsTableTitle: 'Ofertas por año',
        applicationsTableTitle: 'Postulaciones por año',
        applicationsByCareerTitle: 'Postulaciones por carrera',
        usersByCareerTitle: 'Postulantes por carrera',
        tableCareer: 'Carrera',
        tableYear: 'Año',
        tableTotal: 'Total',
        tableActive: 'Activas',
        tableInactive: 'Inactivas',
        careerUnspecified: 'Sin especificar',
        onlyModerators: 'Solo moderadores pueden ver esta pagina.',
        loadError: 'No se pudieron cargar las estadísticas',
        errorTitle: 'Error'
      },
      approvals: {
        title: 'Panel de aprobaciones y monitoreo',
        pendingUsers: 'Usuarios pendientes',
        pendingJobs: 'Empleos pendientes',
        phoneDuplicates: 'Telefonos duplicados',
        dniDuplicates: 'DNIs duplicados',
        noPendingUsers: 'No hay usuarios pendientes de aprobación',
        noPendingJobs: 'No hay empleos pendientes de aprobación',
        noPhoneDuplicates: 'No hay telefonos duplicados',
        noDniDuplicates: 'No hay DNIs duplicados',
        phoneDuplicatesTitle: 'Telefonos duplicados',
        dniDuplicatesTitle: 'DNIs duplicados',
        exportCsv: 'Exportar CSV',
        onlyPending: 'Solo pendientes',
        onlyJobSeekers: 'Solo postulantes',
        onlyResolved: 'Solo resueltos',
        startDate: 'Fecha desde',
        endDate: 'Fecha hasta',
        rolesInvolved: 'Roles involucrados',
        totalAccounts: '{{count}} cuentas',
        pendingAccounts: '{{count}} pendientes',
        approvedAccounts: '{{count}} aprobadas',
        validated: 'Resuelto',
        validatedAt: 'Resuelto el {{date}}',
        notValidated: 'Sin resolver',
        markValidated: 'Marcar resuelto',
        userName: 'Nombre',
        userEmail: 'Correo',
        userRole: 'Rol',
        userStatus: 'Estado',
        userCreated: 'Alta',
        userLastLogin: 'Ultimo acceso',
        statusApproved: 'Aprobado',
        statusPending: 'Pendiente',
        statusRejected: 'Rechazado',
        requested: 'Solicitado',
        posted: 'Publicado',
        editJob: 'Editar aviso',
        approve: 'Aprobar',
        reject: 'Rechazar',
        constancia: 'Constancia',
        cuitCuil: 'CUIT/CUIL',
        cuitCuilNumber: 'CUIT/CUIL (sólo números)',
        resume: 'CV',
        phone: 'Teléfono',
        dni: 'DNI',
        bio: 'Bio',
        career: 'Carrera',
        skills: 'Habilidades',
        companyWebsite: 'Sitio web',
        profilePicture: 'Foto de perfil',
        viewDetails: 'Ver detalles',
        hideDetails: 'Ocultar detalles',
        viewDocument: 'Ver documento',
        pendingApproval: 'Pendiente de aprobacion',
        loadError: 'No se pudieron cargar los pendientes',
        phonesLoadError: 'No se pudieron cargar los telefonos duplicados',
        phoneValidateError: 'No se pudo marcar el telefono como validado',
        dnisLoadError: 'No se pudieron cargar los DNIs duplicados',
        dniValidateError: 'No se pudo marcar el DNI como resuelto',
        approveUserError: 'No se pudo aprobar el usuario',
        rejectUserError: 'No se pudo rechazar el usuario',
        approveJobError: 'No se pudo aprobar el empleo',
        rejectJobError: 'No se pudo rechazar el empleo'
      },
      postedJobs: {
        title: 'Mis avisos publicados',
        subtitle: 'Gestiona los avisos que has publicado.',
        empty: 'Aún no tienes avisos. Publica uno para comenzar.',
        onlyPosters: 'Solo empresas, moderadores o administradores pueden ver avisos propios.',
        forPosters: 'Para empresas',
        viewPostulations: 'Ver postulaciones',
        applicants: 'postulantes',
        active: 'Activa',
        inactive: 'Inactivo',
        reactivate: 'Reactivar',
        deactivate: 'Dar de baja',
        filterActive: 'Solo activas',
        filterInactive: 'Solo inactivas',
        filterAll: 'Todas'
      },
      users: {
        title: 'Usuarios',
        subtitle: 'Ver y editar cuentas de usuario.',
        export: {
          csv: 'Exportar CSV',
          xlsx: 'Exportar XLSX',
          email: 'Correo',
          phone: 'Teléfono',
          firstName: 'Nombre',
          lastName: 'Apellido',
          activityTotal: 'Actividad (total)',
          activity6m: 'Actividad (6m)',
          name: 'Nombre',
          role: 'Rol',
          status: 'Estado'
        },
        noUsers: 'No se encontraron usuarios.',
        loadError: 'No se pudieron cargar los usuarios',
        updateError: 'No se pudo actualizar el usuario',
        updated: 'Usuario actualizado correctamente',
        editTitle: 'Editar usuario',
        save: 'Guardar',
        cancel: 'Cancelar',
        password: {
          new: 'Nueva contraseña',
          confirm: 'Confirmar contraseña',
          mismatch: 'Las contraseñas deben coincidir.',
          tooShort: 'La contraseña debe tener al menos 8 caracteres.'
        },
        search: {
          label: 'Buscar',
          placeholder: 'Nombre, correo o DNI'
        },
        filters: {
          role: 'Rol',
          approval: 'Aprobacion',
          allRoles: 'Todos los roles',
          allApprovals: 'Todos',
          approved: 'Aprobado',
          pending: 'Pendiente',
          rejected: 'Rechazado'
        },
        table: {
          email: 'Correo',
          phone: 'Teléfono',
          activity: 'Actividad',
          name: 'Nombre',
          role: 'Rol',
          approved: 'Aprobado',
          actions: 'Acciones',
          edit: 'Editar'
        },
        activity: {
          applicationsTotal: 'Postulaciones (total): {{count}}',
          applications6m: 'Postulaciones (6m): {{count}}',
          jobsTotal: 'Búsquedas (total): {{count}}',
          jobs6m: 'Búsquedas (6m): {{count}}'
        },
        fields: {
          email: 'Correo',
          firstName: 'Nombre',
          lastName: 'Apellido',
          dni: 'DNI',
          userType: 'Tipo de usuario',
          approved: 'Aprobado',
          phone: 'Telefono',
          companyName: 'Empresa',
          companyWebsite: 'Sitio web',
          bio: 'Bio',
          skills: 'Habilidades',
          skillsHint: 'Separadas por comas',
          profilePicture: 'Foto de perfil',
          resume: 'Curriculum',
          constancia: 'Constancia',
          viewFile: 'Ver archivo'
        }
      },
      profile: {
        title: 'Perfil de usuario',
        subtitle: 'Datos básicos de la cuenta.',
        username: 'Usuario',
        email: 'Correo',
        role: 'Rol',
        approved: 'Aprobado',
        approvedYes: 'Sí',
        approvedPending: 'Pendiente',
        editTitle: 'Editar perfil',
        save: 'Guardar cambios',
        updated: 'Perfil actualizado correctamente',
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellido',
          career: 'Carrera',
          dni: 'DNI',
          phone: 'Telefono',
          cuitCuil: 'CUIT/CUIL (número)',
          companyName: 'Empresa',
          companyWebsite: 'Sitio web',
          bio: 'Bio',
          skills: 'Habilidades',
          skillsHint: 'Separadas por comas'
        },
        password: {
          title: 'Cambiar contraseña',
          current: 'Contraseña actual',
          new: 'Nueva contraseña',
          confirm: 'Confirmar contraseña',
          save: 'Actualizar contraseña',
          updated: 'Contraseña actualizada correctamente',
          mismatch: 'Las contraseñas deben coincidir.',
          tooShort: 'La contraseña debe tener al menos 8 caracteres.'
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es',
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

export default i18n;
